import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Td,
  Tr,
} from "@chakra-ui/react";
import { FiEdit, FiEye, FiSearch, FiTrash } from "react-icons/fi";
import TableView from "../../components/TableView";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../components/ButtonComp";
import CustomToolTip from "../../components/CustomTooltip";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ConfirmDialog from "../../components/ConfirmDialog";
import { toast } from "react-toastify";
import { get_bank_list, update_bank_status } from "../../redux/bankSlice";
import { baseUrl } from "../../utils/utils";

const BankList = () => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [rows, setRows] = useState(5);
  const [page, setPage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const dispatch = useDispatch();
  
  // Use useSearchParams instead of location.state
  const [searchParams] = useSearchParams();
  const fromParam = searchParams.get('from');
  const fromCash = fromParam === 'cash';
  
  const { bank_list, total_bank_count } = useSelector(
    (state) => state.banks
  );
  
  console.log(bank_list, "bankssssss");
  console.log("URL search params:", searchParams.toString()); // Debug log
  console.log("from parameter:", fromParam); // Debug log
  console.log("fromCash boolean:", fromCash); // Debug log
  console.log("Current URL:", window.location.href); // Debug log
  
  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "delete");
      formData.append("id", deleteId);

      const response = await fetch(baseUrl + `bank.php`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to delete bank: ${response.statusText}`);
      }

      const result = await response.json();
      console.log(result);
      
      if (result?.success) {
        store.dispatch(get_bank_list({ page: page, rows: rows }));
        toast.success(result?.message || "Bank deleted successfully");
        setDeleteId(null);
        setDeleteDialog(false);
      } else {
        toast.error(result?.message || "Failed to delete bank");
      }
    } catch (error) {
      console.error("Error deleting bank:", error);
      toast.error("Failed to delete bank", {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const viewBankDetails = (bankId) => {
    navigate(`bank-detail/${bankId}`);
  };

  useEffect(() => {
    store.dispatch(get_bank_list({ page: page, rows: rows }));
  }, [page, rows]);

  return (
    <>
      <Card
        bg="#fff"
        p={2}
        flexDirection={["column", "row"]}
        alignItems={["stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <InputGroup bg="#f4f5f7" borderRadius={5} w={["100%", "sm"]}>
          <Input placeholder="Search banks..." />
          <InputRightElement>
            <FiSearch />
          </InputRightElement>
        </InputGroup>

        <Spacer display={["none", "block"]} />

        <CustomButton
          title="Add Cash"
          onClick={() => navigate("/banks/add-cash")}
          w={["100%", "auto"]}
        />
        <CustomButton
          title="Add Bank"
          onClick={() => navigate("/banks/add-bank")}
          w={["100%", "auto"]}
        />
      </Card>

      <div>
        <TableView
          headData={[
            "", // radio column header
            "Bank Name",
            "Branch Name",
            "Account Type",
            "Account No.",
            "IFSC Code",
            "Opening Balance",
            "Closing Balance",
            "Action",
          ]}
          body={bank_list?.map((bank) => (
            <Tr key={bank.id}>
              {/* Radio for default bank - Updated condition */}
              <Td textAlign="center">
                {!(fromCash && bank.ac_type?.toLowerCase() === "cash") && (
                  <input
                    type="radio"
                    name="defaultBank"
                    checked={bank.de_status === "1"}
                    onChange={() => {
                      dispatch(update_bank_status(bank.id)).then((res) => {
                        if (res.meta.requestStatus === "fulfilled") {
                          toast.success(res.payload?.message || "Default bank updated");
                          dispatch(get_bank_list({ page, rows }));
                        } else {
                          toast.error(res.payload || "Failed to update default status");
                        }
                      });
                    }}
                  />
                )}
              </Td>

              {/* Existing data columns */}
              <Td textAlign="center">{bank.bankname}</Td>
              <Td textAlign="center">{bank.bank_branch}</Td>
              <Td textAlign="center">{bank.ac_type}</Td>
              <Td textAlign="center">{bank.accountno}</Td>
              <Td textAlign="center">{bank.ifsc}</Td>
              <Td textAlign="center">{bank.acc_ob}</Td>
              <Td textAlign="center">{bank.acc_cb}</Td>
        
              {/* Action column as before */}
              <Td textAlign="center">
                <Flex justify="center" gap={4} align="center">
                  <CustomToolTip
                    button={
                      <FiEye
                        size={20}
                        color="#0175c2"
                        cursor="pointer"
                        onClick={() => viewBankDetails(bank.id)}
                      />
                    }
                    mess="View Bank"
                  />
                  <CustomToolTip
                    button={
                      <FiTrash
                        size={20}
                        cursor="pointer"
                        color="#F00"
                        onClick={() => {
                          setDeleteId(bank.id);
                          setDeleteDialog(true);
                        }}
                      />
                    }
                    mess="Delete Bank"
                  />
                </Flex>
              </Td>
            </Tr>
          ))}

          initialValue={initialValue}
          page={page}
          rows={rows}
          total_value={total_bank_count}
          pagination
          onChange={(e) => {
            setInitialValue(1);
            setPage(1);
            console.log("New rows value:", e.target.value);
            store.dispatch(
              get_bank_list({ page: 1, rows: e.target.value })
            );
            setRows(e.target.value);
          }}
          onPrevious={() => {
            if (initialValue > 1) {
              setInitialValue(Number(initialValue) - Number(rows));
            }
            if (page > 1) {
              setPage(page - 1);
              store.dispatch(
                get_bank_list({ page: page - 1, rows: rows })
              );
            }
          }}
          onNext={() => {
            if (rows * page < total_bank_count) {
              setInitialValue(Number(initialValue) + Number(rows));
              setPage(page + 1);
              store.dispatch(
                get_bank_list({ page: page + 1, rows: rows })
              );
            }
          }}
        />
        
        <ConfirmDialog
          isOpen={deleteDialog}
          onClose={() => setDeleteDialog(false)}
          onConfirm={handleDelete}
          type="delete"
          title="Delete Bank"
          message="Are you sure you want to delete this bank? This action cannot be undone and will remove all associated data."
          confirmText="Delete"
          cancelText="Cancel"
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default BankList;